module.exports = __webpack_public_path__ + "img/equip-title.47e761c0.png";